<template>
  <div class="container mt-3">
    
    <NavBar 
        :items="['enterprises', 'enrolment profiles']"
        :active="curSection"
        @navigate="navbarClickHandler($event)"
        />

    <EnterpriseList v-if="curSection === 'enterprises'"/>
    <EnrolProfileList v-if="curSection === 'enrolment profiles'"/>

  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { curPref } from '@/services/Preferences';
import NavBar from '@/components/NavBar.vue';
import EnterpriseList from '@/components/admin/EnterpriseList.vue';
import EnrolProfileList from '@/components/admin/EnrolProfileList.vue';


const curSection = ref(curPref.retrieve('noc-admin-cur-section', 'enterprises'));

onMounted(() => {
  // todo
});

function navbarClickHandler(newSection: string) {
  curPref.store('noc-admin-cur-section', newSection);
  curSection.value = newSection;
}
</script>


<style scoped lang="scss">


</style>